import { Box, Divider, Paper } from "@mui/material";

const NoResult = () => {
  return (
    <>
      <Box sx={{ margin: "20px 0" }}>검색 결과가 없습니다.</Box>
      <Divider />
    </>
  );
};

export default NoResult;
